import { ChannelType } from "@/modules/chat/gateway/channelTypes"
import { useChatClient } from "@/modules/chat/stores/useChatStore"
import { useChatContext } from "stream-chat-react"
import { v4 as uuidv4 } from "uuid"

export const useCreateChannel = () => {
  const chatClient = useChatClient()
  const { setActiveChannel } = useChatContext()

  const createOneToOneChannel = async (userId: string) => {
    if (!chatClient?.user?.id) {
      return
    }

    const members = [chatClient.user.id, userId]

    // Check if the channel already exists.
    const channels = await chatClient.queryChannels({
      members,
    })

    const newChannel =
      channels.length === 1
        ? channels[0]
        : chatClient.channel(ChannelType.PRIVATE, {
            members,
          })

    if (!newChannel?.initialized) {
      await newChannel?.watch()
    }

    if (Object.keys(newChannel?.state.members ?? {}).length < 2) {
      if (!newChannel?.state.members[chatClient.user.id]) {
        await newChannel?.addMembers([chatClient.user.id])
      }
      if (!newChannel?.state.members[userId]) {
        await newChannel?.addMembers([userId])
      }
    }

    setActiveChannel(newChannel)
    return newChannel
  }

  const createGroupChannel = async (groupName: string, selectedUserIds: string[]) => {
    if (!chatClient?.user || selectedUserIds.length === 0 || !groupName) {
      return
    }

    const newChannel = chatClient.channel(ChannelType.PRIVATE, uuidv4(), {
      members: selectedUserIds,
      team: groupName,
    })

    await newChannel.create()

    if (!newChannel.initialized) {
      await newChannel.watch()
    }

    setActiveChannel(newChannel)
  }

  return { createOneToOneChannel, createGroupChannel }
}
